export default "__VITE_PUBLIC_ASSET__8b85c06f__"